export default __webpack_public_path__ + "static/media/sold_out_img.1c4796a3.png";